/**
 * Represents binary input data that can be processed by AES APIs.
 * When providing a string, it must be base64-encoded.
 */ /**
 * AES key sizes in bits.
 */ export var AESKeySize = /*#__PURE__*/ function(AESKeySize) {
    /** 128-bit AES key */ AESKeySize[AESKeySize["AES128"] = 128] = "AES128";
    /** 192-bit AES key. It is unsupported on Web.
   * @platform apple
   * @platform android
   */ AESKeySize[AESKeySize["AES192"] = 192] = "AES192";
    /** 256-bit AES key */ AESKeySize[AESKeySize["AES256"] = 256] = "AES256";
    return AESKeySize;
}({});

//# sourceMappingURL=aes.types.js.map
